import { useSelector } from 'react-redux';

import Notification from './Notification';
import UserInformation from './UserInformation';

import classes from './HeaderRight.module.scss';

export default function HeaderRight({ openSignupModal, openLoginModal, t }) {
  const isLogedIn = useSelector((state) => state.authentication.isLogedIn);

  return (
    <div className={classes['right-container']}>
      <Notification />
      {!isLogedIn && (
        <button onClick={openSignupModal} className={classes.signup}>
          {t('signup')}
        </button>
      )}
      {!isLogedIn && (
        <button onClick={openLoginModal} className={classes.login}>
          {t('login')}
        </button>
      )}
      {isLogedIn && <UserInformation />}
    </div>
  );
}
